import React, { useState } from 'react';
import {
    Box,
    Container,
    Paper,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { usePermission } from '../../hooks/usePermission';
import RoleForm from '../../Components/Roles/RoleForm';
import RoleTable from '../../Components/Roles/RoleTable';
import { CreateRolesPermission } from '../../constants/permissions';

const Roles = () => {
    const { data: canCreateRole } = usePermission({
        permissionName: CreateRolesPermission
    });

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        permissions: []
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData({
            name: '',
            description: '',
            permissions: []
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Container maxWidth="xl">
            <Box sx={{ py: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <Typography variant="h4" component="h1">
                        Roles
                    </Typography>
                    {canCreateRole && (
                        <button
                            className='bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2'
                            onClick={handleClickOpen}
                        >
                            <AddIcon />
                            Add New Role
                        </button>
                    )}
                </Box>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <RoleTable />
                </Paper>

                <RoleForm
                    open={open}
                    onClose={handleClose}
                    formData={formData}
                    onInputChange={handleInputChange}
                />
            </Box>
        </Container>
    );
};

export default Roles; 